var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScatter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 19.6a2.5 2.5 0 001.7-4.2c-1-1-2.5-1-3.5 0a2.5 2.5 0 001.8 4.2zm3.9-9.2a1.9 1.9 0 001.3-3.2c-.7-.7-1.9-.7-2.6 0a1.9 1.9 0 001.3 3.2zm8 10.6c2 0 3.7-1.7 3.7-3.7 0-1-.4-1.9-1-2.6a3.7 3.7 0 10-2.7 6.4zm4.2-13.6a2.2 2.2 0 001.5-3.8 2.2 2.2 0 10-1.5 3.7zm4.6 17.1H2.8V.3c0-.2-.1-.3-.3-.3H.3C.1 0 0 .1 0 .3V27c0 .2 0 .4.3.4h29.1c.2 0 .4-.2.3-.4v-2.1c0-.2-.1-.3-.3-.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatter);
export default __webpack_public_path__ + "static/media/scatter.17d8ea23.svg";
export { ForwardRef as ReactComponent };